"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : SEARCH BAR : CATEGORY SELECTOR : STYLES --------------- ++++++++++ */


var _default = {
  categoryselector: {
    position: 'relative',
    fontWeight: 500,
    '& .selector': {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      padding: (0, _index.replacePXinStringWithEM)('0 20px'),
      '& .icon': {
        width: (0, _index.pxToEm)(13),
        display: 'flex',
        alignItems: 'flex-start',
        alignContent: 'flex-start',
        justifyContent: 'flex-start',
        color: _index.theme.color.primary.dark.swatch,
        margin: (0, _index.replacePXinStringWithEM)("-5px 5px 0 0"),
        cursor: 'pointer'
      },
      '& .currentselection': {
        color: _index.theme.color.primary.medium.swatch,
        cursor: 'pointer'
      }
    },
    '& .menu': {
      opacity: '0',
      zIndex: '-1',
      pointerEvents: 'none',
      boxShadow: (0, _index.replacePXinStringWithEM)('0px 4px 4px 0px rgba(0, 0, 0, 0.08)'),
      border: '1px solid rgb(239, 239, 239)',
      position: 'absolute',
      background: 'white',
      width: 'fit-content',
      '& .item': {
        padding: (0, _index.replacePXinStringWithEM)("".concat((0, _index.pxToEm)(13), " ").concat((0, _index.pxToEm)(42))),
        height: (0, _index.pxToEm)(42),
        width: (0, _index.pxToEm)(237),
        color: _index.theme.color.primary.dark.swatch,
        cursor: 'pointer',
        '&:after': {
          background: 'rgb(242, 244, 248)',
          content: '" "',
          display: 'inline-block',
          height: (0, _index.pxToEm)(1),
          width: '100%'
        },
        '&.selected-true': {
          // filter: 'grayscale(100%)',
          color: _index.theme.color.primary.medium.swatch,
          pointerEvents: 'none',
          cursor: 'normal'
        },
        '&:hover': {
          color: _index.theme.color.primary.medium.swatch
        },
        '&:last-child': {
          '&:after': {
            display: 'none'
          }
        }
      }
    },
    '&.active-true': {
      '& .menu': {
        pointerEvents: 'auto',
        animationName: 'fadeIn',
        animationDuration: '.15s',
        animationFillMode: 'forwards',
        animationDelay: '0s',
        zIndex: '2'
      }
    }
  }
};
exports.default = _default;